// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";
import * as RestrictedVehicleCardCmp from "./RestrictedVehicleCardCmp.bs.js";
import * as RestrictedVehiclesVmMapper from "../../vm-mapper/RestrictedVehiclesVmMapper.bs.js";
import * as UnRestrictedVehicleCardCmp from "./UnRestrictedVehicleCardCmp.bs.js";
import * as UnRestrictedVehiclesVmMapper from "../../vm-mapper/UnRestrictedVehiclesVmMapper.bs.js";

var locationLine = PlaceOrderAssetsManager.getImage("location-line.svg");

function VehicleSectionSectionCmp(Props) {
  var vehicles = Props.vehicles;
  var quotations = Props.quotations;
  var selectedVehicle = Props.selectedVehicle;
  var onSelectVehicle = Props.onSelectVehicle;
  var match = PlaceOrderContext.useContext(undefined);
  var dispatch = match.dispatch;
  var unrestrictedVehiclesVM = UnRestrictedVehiclesVmMapper.getVM(vehicles.vehicles.on_demand, quotations);
  var restrictedVehiclesVm = RestrictedVehiclesVmMapper.getVM(vehicles.vehicles.on_demand, match.state.restricted_vehicles);
  React.useEffect((function () {
          var vehicle = unrestrictedVehiclesVM.find(function (e) {
                return e.vehicle_id === selectedVehicle.vehicle_id;
              });
          if (vehicle !== undefined) {
            Curry._1(dispatch, {
                  TAG: /* SetSelectedVehicle */2,
                  _0: vehicle
                });
          }
          
        }), []);
  return React.createElement("div", {
              className: "section__container"
            }, React.createElement("span", {
                  className: "title"
                }, "VEHICLE SELECTION"), React.createElement("div", {
                  className: "vehicle-cards"
                }, React.createElement(React.Fragment, undefined, $$Array.map((function (vehicle) {
                            var isVehicleSelected = selectedVehicle.vehicle_id === vehicle.vehicle_id;
                            return React.createElement(UnRestrictedVehicleCardCmp.make, {
                                        displayName: vehicle.vehicle_name,
                                        vehicleImgs: vehicle.vehicle_imgs,
                                        fare: vehicle.fare_info.fare,
                                        nearbyVehiclesCount: vehicle.nearby_vehicles,
                                        etaMins: vehicle.eta_mins,
                                        vehicleCapacityDetails: vehicle.details,
                                        isSelected: isVehicleSelected,
                                        onSelectVehicle: (function (param) {
                                            if (selectedVehicle.vehicle_id !== vehicle.vehicle_id) {
                                              return Curry._1(onSelectVehicle, vehicle);
                                            }
                                            
                                          }),
                                        key: String(vehicle.vehicle_id)
                                      });
                          }), unrestrictedVehiclesVM), $$Array.map((function (vehicle) {
                            return React.createElement(RestrictedVehicleCardCmp.make, {
                                        displayName: vehicle.vehicle_name,
                                        vehicleImgs: vehicle.vehicle_imgs,
                                        vehicleCapacityDetails: vehicle.details,
                                        key: String(vehicle.vehicle_id)
                                      });
                          }), restrictedVehiclesVm))));
}

var make = VehicleSectionSectionCmp;

export {
  locationLine ,
  make ,
  
}
/* locationLine Not a pure module */
